var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyllabousArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_24045",
    x: 0,
    y: 0,
    width: 125,
    height: 124,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_94247",
    x: 35.828,
    y: 35.329,
    width: 53.343,
    height: 53.343,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47827",
    "data-name": "Group 47827",
    transform: "translate(-547.5 -2890.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 547.5, 2890.5)",
    filter: "url(#Rectangle_24045)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24045-2",
    "data-name": "Rectangle 24045",
    width: 80,
    height: 79,
    rx: 9,
    transform: "translate(22.5 22.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 547.5, 2890.5)",
    filter: "url(#Path_94247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94247-2",
    "data-name": "Path 94247",
    d: "M60.2,64.744,57.3,67.638l9.3,9.3L87.276,56.269l-2.894-2.894L66.6,71.048l-6.408-6.3Zm25.013,3.927A16.466,16.466,0,1,1,73.219,52.755l3.2-3.2A19.228,19.228,0,0,0,68.671,48,20.671,20.671,0,1,0,89.343,68.671Z",
    transform: "translate(-6.17 -6.67)",
    fill: "#a1a3ef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabousArrow);
export default __webpack_public_path__ + "static/media/syllabous-arrow.1f98b485f1780f90029d7ce3f1c878ad.svg";
export { ForwardRef as ReactComponent };